import { render, staticRenderFns } from "./EditReception.vue?vue&type=template&id=c16dfd2e&"
import script from "./EditReception.vue?vue&type=script&lang=js&"
export * from "./EditReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports